import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { toMoney } from '../../views/invoice-tool/amount/amount-helper';
import Utils from 'frilans-finans/utils/utils';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

export class InvoiceDetailsWorkerAmount extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    invoice: PropTypes.object.isRequired,
    currencyId: PropTypes.number.isRequired,
    outlaysAmount: PropTypes.number.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      showWorkers: false
    };

    this.showWorkers = this.showWorkers.bind(this);
  }

  isOwner (worker) {
    return worker.userId === this.props.user.userId;
  }

  toPayAmount (worker) {
    let toPay = worker.net + worker.allowance + worker.travel;
    if (this.isOwner(worker)) {
      toPay += this.props.outlaysAmount;
    }
    return toPay;
  }

  pensionAmount (worker) {
    const vacationRate = worker.saveVacationPay ? 1.12 : 1;
    const gross = worker.gross * vacationRate;
    return gross * worker.itpRate;
  }

  vacationAmount (worker) {
    return worker.saveVacationPay ? worker.gross * 0.12 : 0;
  }

  getAmountWithCurrency (amount) {
    return Utils.amountWithCurrency(toMoney(amount), this.props.currencyId);
  }

  workerAllowance (worker) {
    if (worker.allowance) {
      return (
        <div className='invoice-details-allowance-details'>
          <Translate className='invoice-details-amount-title' content='ALLOWANCE' />
          <div className='invoice-details-amount-title'>{this.getAmountWithCurrency(worker.allowance)}</div>
        </div>
      );
    }
    return null;
  }

  workerTravel (worker) {
    if (worker.travel) {
      return (
        <div className='invoice-details-allowance-details'>
          <Translate className='invoice-details-amount-title' content='TRAVEL_ALLOWANCE' />
          <div className='invoice-details-amount-title'>{this.getAmountWithCurrency(worker.travel)}</div>
        </div>
      );
    }
    return null;
  }

  workerToPay (worker) {
    return (
      <div className='invoice-details-amount-details green'>
        <Translate className='invoice-details-amount-title' content='REVIEW_AND_CREATE_INVOICE_TO_PAY' />
        <div className='invoice-details-amount-title'>{this.getAmountWithCurrency(this.toPayAmount(worker))}</div>
      </div>
    );
  }

  workerPension (worker) {
    if (worker.saveItp) {
      return (
        <div className='invoice-details-amount-details light-green'>
          <Translate className='invoice-details-amount-title' content='REVIEW_AND_CREATE_INVOICE_TO_PAY_ITP' />
          <div className='invoice-details-amount-title'>{this.getAmountWithCurrency(this.pensionAmount(worker))}</div>
        </div>
      );
    }
    return null;
  }

  workerVacation (worker) {
    if (worker.saveVacationPay) {
      return (
        <div className='invoice-details-amount-details light-green'>
          <Translate className='invoice-details-amount-title' content='REVIEW_AND_CREATE_INVOICE_TO_PAY_VACATION' />
          <div className='invoice-details-amount-title'>{this.getAmountWithCurrency(this.vacationAmount(worker))}</div>
        </div>
      );
    }
    return null;
  }

  totalNet (worker) {
    const amount = this.toPayAmount(worker) + this.pensionAmount(worker) + this.vacationAmount(worker);
    return (
      <div className='invoice-details-amount-details white'>
        <Translate className='invoice-details-amount-title' content='REVIEW_AND_CREATE_INVOICE_TO_BE_PAID_TOTAL' />
        <div className='invoice-details-amount-title'>{this.getAmountWithCurrency(amount)}</div>
      </div>
    );
  }

  renderAllowanceContainer (worker) {
    if (this.props.user.allowance || this.props.user.travel) {
      return (<div className='invoice-details-allowance-container'>
        {this.workerAllowance(worker)}
        {this.workerTravel(worker)}
      </div>);
    }

    return null;
  }

  renderWorkerAmounts () {
    const workers = [];
    let owner;

    this.props.invoice.invoiceUsers.forEach((worker) => {
      const workerTitle = this.isOwner(worker)
        ? <div className='invoice-details-title'>{proxyCounterpart('INVOICE_DETAILS_YOUR_COMPENSATION')}</div>
        : <div className='invoice-details-title text-transform-none'>{worker.firstName} {worker.lastName}</div>;
      const workerAmounts = (
        <div key={worker.userId}>
          {workerTitle}
          {this.renderAllowanceContainer(worker)}
          <div className='invoice-details-amount-container margin-bottom'>
            {this.workerToPay(worker)}
            {this.workerPension(worker)}
            {this.workerVacation(worker)}
            {this.totalNet(worker)}
          </div>
        </div>
      );

      if (this.isOwner(worker)) {
        owner = workerAmounts;
      } else {
        workers.push(workerAmounts);
      }
    });
    const coworkersTitle = this.props.invoice.invoiceUsers.length > 1
      ? (<div
        className='invoice-details-title clickable'
        onClick={this.showWorkers}
      >
        {this.state.showWorkers ? '- ' : '+ '}
        {proxyCounterpart('COWORKERS')}
      </div>)
    : null;

    return (
      <div className='invoice-details-part-container'>
        {owner}
        {coworkersTitle}
        {this.state.showWorkers ? workers : null}
      </div>
    );
  }

  showWorkers () {
    this.setState({
      showWorkers: !this.state.showWorkers
    });
  }

  render () {
    return this.renderWorkerAmounts();
  }
}

export default InvoiceDetailsWorkerAmount;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/worker-amount.js
 **/